import { useEffect } from 'react';
import { publicApi } from '../context/AuthContext';

export default function GTMContainer() {
  useEffect(() => {
    const loadGTM = async () => {
      try {
        const { data } = await publicApi.get('/settings/public');
        const gtmId = data.gtm_id;

        if (!gtmId || !gtmId.startsWith('GTM-')) {
          return;
        }

        if (window.dataLayer && window.google_tag_manager) {
          return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);

      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('GTM init skipped:', error?.message || error);
        }
      }
    };

    loadGTM();
  }, []);

  return null;
}
